import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompleteAuthorityClaimMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CompleteAuthorityClaimMutation = { __typename?: 'mutation_root', complete_authority_claim: { __typename?: 'CompleteAuthorityClaimOutput', status: string, jurisdiction_name: string } };


export const CompleteAuthorityClaimDocument = gql`
    mutation CompleteAuthorityClaim {
  complete_authority_claim {
    status
    jurisdiction_name
  }
}
    `;
export type CompleteAuthorityClaimMutationFn = Apollo.MutationFunction<CompleteAuthorityClaimMutation, CompleteAuthorityClaimMutationVariables>;

/**
 * __useCompleteAuthorityClaimMutation__
 *
 * To run a mutation, you first call `useCompleteAuthorityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAuthorityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAuthorityClaimMutation, { data, loading, error }] = useCompleteAuthorityClaimMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompleteAuthorityClaimMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAuthorityClaimMutation, CompleteAuthorityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAuthorityClaimMutation, CompleteAuthorityClaimMutationVariables>(CompleteAuthorityClaimDocument, options);
      }
export type CompleteAuthorityClaimMutationHookResult = ReturnType<typeof useCompleteAuthorityClaimMutation>;
export type CompleteAuthorityClaimMutationResult = Apollo.MutationResult<CompleteAuthorityClaimMutation>;
export type CompleteAuthorityClaimMutationOptions = Apollo.BaseMutationOptions<CompleteAuthorityClaimMutation, CompleteAuthorityClaimMutationVariables>;